import React from 'react';
import './TitleSection.css';

const TitleSection = () => (
  <div className="text-section-intitle">
    <h1 className="title-intitle">
      Revolutionize 
      <span className="title-second-line-intitle">AI Accuracy</span>
    </h1>
    <h2 className="subtitle-intitle">Join the Future Today!</h2>
  </div>
);

export default TitleSection;
